export default __webpack_public_path__ + "static/media/Mob_375x360px.3107563d.png";